module.exports = __webpack_public_path__ + "img/verify_fail.049401e9.svg";